import { useEffect } from "react";
import { MessageCircle, X, Sparkles, FileText, UserCheck, Compass } from "lucide-react";
import { INTENTS } from "@/lib/agentFlow";
import { useAgente } from "./agente/AgenteContext";
import { AgenteChat } from "./agente/AgenteChat";

export { AgenteProvider } from "./agente/AgenteContext";
export const openAgente = (detail) => window.dispatchEvent(new CustomEvent("fiin:open", { detail: detail || {} }));

export const AgenteFiin = () => {
  const { open, setOpen, embeddedVisible } = useAgente();
  return (
    <>
      <button data-testid="agente-fiin-chat-toggle" onClick={() => setOpen((o) => !o)} aria-label="Abrir Agente Fiin"
        className={`fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full pl-4 pr-5 py-3 text-[#0B0B0B] font-semibold shadow-[0_12px_40px_-10px_rgba(255,122,0,.8)] brand-gradient transition-all duration-300 hover:scale-105 active:scale-95 ${embeddedVisible && !open ? "opacity-0 translate-y-4 pointer-events-none" : "opacity-100"}`}>
        {open ? <X size={20} /> : <MessageCircle size={20} />}<span className="hidden sm:inline font-display">Agente Fiin</span>
      </button>
      {open && <div data-testid="agente-fiin-panel" className="fixed bottom-20 right-4 sm:right-5 z-50 w-[calc(100vw-2rem)] sm:w-[420px] h-[min(640px,calc(100vh-7rem))] rounded-3xl overflow-hidden shadow-2xl border border-white/10 fade-up"><AgenteChat variant="panel" /></div>}
    </>
  );
};

const CAPS = [
  [Compass, "Te orienta", "Crédito, seguros, inversiones o franquicia: requisitos, rangos y qué te conviene según tu perfil."],
  [FileText, "Propuesta en minutos", "Genera una propuesta indicativa en PDF con pago estimado, tasa y CAT, o proyección de inversión."],
  [UserCheck, "Te conecta", "Inicia tu solicitud en línea o canaliza tu caso al asesor certificado de tu zona; honorarios solo al éxito."],
];

export const AgenteSection = () => {
  const { embeddedRef, setEmbeddedVisible, answer, step, profile } = useAgente();
  useEffect(() => {
    const el = embeddedRef.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => setEmbeddedVisible(e.isIntersecting && e.intersectionRatio > 0.35), { threshold: [0, 0.35, 0.7] });
    io.observe(el);
    return () => { io.disconnect(); setEmbeddedVisible(false); };
  }, []); // eslint-disable-line
  return (
    <section id="agente" ref={embeddedRef} className="bg-[#FFF6EC] py-20 scroll-mt-16" data-testid="agente-section">
      <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-[.85fr_1.15fr] gap-10 items-start">
        <div>
          <p className="eyebrow flex items-center gap-1.5"><Sparkles size={12} /> Agente Fiin · Inteligencia artificial</p>
          <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">Cuéntale a Agente Fiin qué necesitas y avanza hoy mismo.</h2>
          <p className="mt-4 text-sm text-[#575757] leading-relaxed">Conversa aquí, sin formularios. Te orienta, te da una propuesta indicativa y te conecta con el asesor de tu zona. Tu conversación se guarda para retomarla cuando quieras.</p>
          <div className="mt-8 space-y-4">{CAPS.map(([Icon, t, d]) => <div key={t} className="flex gap-3"><div className="h-9 w-9 shrink-0 rounded-lg bg-white border border-border grid place-items-center text-[#FF7A00]"><Icon size={18} /></div><div><div className="font-display font-bold text-sm">{t}</div><p className="text-xs text-[#575757] mt-0.5 leading-relaxed">{d}</p></div></div>)}</div>
          {!profile.vertical && step?.key === "intent" && <div className="mt-8"><div className="text-xs font-semibold text-[#8A8A8A] uppercase tracking-wider">Empieza con un clic</div><div className="mt-2 flex flex-wrap gap-2">{INTENTS.map(([k, l]) => <button key={k} data-testid={`agente-section-intent-${k}`} onClick={() => answer("intent", k, l)} className="rounded-full bg-white border border-border px-3 py-1.5 text-xs font-semibold hover:border-[#FF7A00] hover:text-[#FF7A00] transition-colors">{l}</button>)}</div></div>}
          <p className="mt-8 text-[11px] text-[#8A8A8A]">Agente Fiin informa y simula; no pre-aprueba crédito ni garantiza rendimientos. Nunca te pedirá contraseñas ni NIP.</p>
        </div>
        <div className="rounded-3xl overflow-hidden shadow-2xl border border-black/5 h-[600px] sm:h-[640px]"><AgenteChat variant="embedded" /></div>
      </div>
    </section>
  );
};
